import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../store/hooks"
import { selectAuthStatus } from "../store/auth/selectors"
import { selectSearch } from "../store/router/selectors"
import { getUrlParameter } from "../utility/common/urlHelper"
import { push } from "connected-react-router"

const redirectParamKey = "continue"

export const useRedirect = (preventRedirect?: boolean) => {
    const authenticated = useAppSelector(selectAuthStatus)
    const search = useAppSelector(selectSearch)
    const dispatch = useAppDispatch()
    useEffect(() => {
        const redirectUrl = getUrlParameter(redirectParamKey, search)
        if (authenticated) {
            if (authenticated && !preventRedirect) {
                if (redirectUrl) {
                    window.location.href = redirectUrl
                } else {
                    dispatch(push("/"))
                }
            }
        }
    }, [authenticated, search, dispatch, preventRedirect])
}
